import { useTranslation } from 'react-i18next';

export default function PillarsSection() {
  const { t } = useTranslation();

  const pillars = [
    { key: 'prayer', heading: t('pillars.prayer.heading'), body: t('pillars.prayer.body') },
    { key: 'oneness', heading: t('pillars.oneness.heading'), body: t('pillars.oneness.body') },
    { key: 'earth', heading: t('pillars.earth.heading'), body: t('pillars.earth.body') },
  ];

  return (
    <section className="py-16 md:py-20 bg-[#06121F]">
      <div className="max-w-6xl mx-auto px-6">
        {/* 3本柱カード */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {pillars.map((pillar) => (
            <div
              key={pillar.key}
              className="rounded-2xl bg-white/5 border border-white/15 backdrop-blur p-6 md:p-8 transition-all duration-300 hover:bg-white/[0.07] hover:border-white/25 hover:shadow-[0_10px_40px_rgba(0,0,0,0.35)]"
            >
              <h3 className="text-xl md:text-2xl font-serif text-white/90 tracking-wide">
                {pillar.heading}
              </h3>
              {/* 見出し下装飾（細いグラデ線） */}
              <div className="mt-3 mb-4 h-px w-10 bg-gradient-to-r from-white/0 via-white/30 to-white/0" />
              <p className="text-white/70 leading-relaxed">
                {pillar.body}
              </p>
            </div>
          ))}
        </div>

        {/* 詩的なメッセージ（v0.8.1 追加） */}
        <div className="mt-16 text-center space-y-4">
          <p className="text-white/90 font-serif text-lg md:text-xl tracking-widest">
            {t('pillars.poem.line1')}
          </p>
          <div className="space-y-1 text-white/70 text-base md:text-lg">
            <p>{t('pillars.poem.line2')}</p>
            <p>{t('pillars.poem.line3')}</p>
            <p>{t('pillars.poem.line4')}</p>
          </div>
          <p className="text-white/90 font-serif text-lg md:text-xl tracking-widest pt-2">
            {t('pillars.poem.line5')}
          </p>
        </div>
      </div>
    </section>
  );
}
